import React, { useEffect, useState } from "react";
import { Box, Grid, Typography } from "@mui/material";
import { CityOverviewType } from "../../types/record";
import CircleProgress from "./CircleProgress";
import { SPColor } from "../../constants/color";
import ClockIcon from "../../assets/images/clock.png";
import ClassIcon from "../../assets/images/class.png";
import StudentsIcon from "../../assets/images/students.png";
import SchoolIcon from "../../assets/images/school.png";
import { TikTok } from "react-tiktok";
import TikTokImg from "../../assets/images/tiktok_image.jpg";
import TikTokIcon from "../../assets/images/tiktok_300.png";

import MOELogo from "../../assets/images/MOE logo.png";
import ClevelandJF from "../../assets/images/ClevelandJF logo.png";
import BSSTEM from "../../assets/images/BS STEM logo.png";
import SellChallenge from "../../assets/images/sel_challenge.png";

type CityOverviewProps = {
  cityOverview: CityOverviewType | null;
  tiktokUrl: string;
};

export default function CityOverview({
  cityOverview,
  tiktokUrl,
}: CityOverviewProps) {
  const [tiktokShow, setTiktokShow] = useState<boolean>(false);

  if (!cityOverview) {
    return null;
  }

  return (
    <Box>
      <Grid container>
        <Grid item md={3} xs={6}>
          <CircleProgress
            value={cityOverview["speaking-hours"]}
            text="שעות דיבור"
            color={SPColor.YELLOW}
            icon={<img src={ClockIcon} alt="clock" width={"100%"} />}
          />
        </Grid>

        <Grid item md={3} xs={6}>
          <CircleProgress
            value={cityOverview["students"]}
            text="תלמידים"
            color={SPColor.ORANGE}
            icon={<img src={StudentsIcon} alt="clock" width={"100%"} />}
          />
        </Grid>
        <Grid item md={3} xs={6}>
          <CircleProgress
            value={cityOverview["classes"]}
            text="כיתות"
            color={SPColor.GREEN}
            icon={<img src={ClassIcon} alt="clock" width={"100%"} />}
          />
        </Grid>
        <Grid item md={3} xs={6}>
          <CircleProgress
            value={cityOverview["schools"]}
            text="בתי ספר"
            color={SPColor.BLUE}
            icon={<img src={SchoolIcon} alt="clock" width={"100%"} />}
          />
        </Grid>
      </Grid>
      <Box sx={{ direction: "RTL", marginTop: 6, textAlign: "justify" }}>
        <Typography>
          בשנים האחרונות, כחלק מתהליך הגלובליזציה, אנגלית דבורה הפכה להיות
          מיומנות נדרשת להתקדמות בחיים המודרניים בעבודה, בלימודים, בתיירות ובכל
          תחום אחר. במטרה לקדם את האנגלית הדבורה בקרב תלמידי בית-שאן, מינהל
          החינוך בעירייה השיק פרויקט עירוני נרחב. במסגרת הפרויקט משולבת סביבת
          לימוד דיגיטלית ויבוצעו ימי שיא בבתי הספר. הפרויקט מבוצע בשיתוף פעולה
          עם חברת ספיקינגפאל SpeakingPal הישראלית שהינה מובילה עולמית בתחום
          לימודי האנגלית הדבורה. הפרוייקט יקדם את התחומים הבאים:{" "}
        </Typography>
        <Typography>
          <ul>
            <li>שיפור רמת הדיבור באנגלית בקרב תלמידי בית-שאן</li>
            <li>
              שיפור רמת הביטחון העצמי לדבר באנגלית ולהשתמש באנגלית באופן כללי
            </li>
            <li>העלאת המודעות לחשיבות האנגלית</li>
            <li>שיתוף הורים וקהילה</li>
            <li>
              עידוד עזרה הדדית והשקעה קבוצתית בתחום האנגלית הדבורה בעזרת תחרות
              עירונית בין כיתות
            </li>
          </ul>
        </Typography>
        <Typography>
			<strong>ההורים מוזמנים להשתתף גם בתרגול עצמו </strong> 
           - במסגרת הפרויקט ההורים מקבלים
		   <strong> רישיון חינם לשימוש בסימולטור השיחה באנגלית. </strong> 
			ניתן להיכנס מאתר החברה
          www.speakingpal.com או להתקין את אפליקציית SpeakingPal Speak English
			לטלפון הנייד - בכניסה לבחור
			<strong> ״הזדהות משרד החינוך״ </strong> 
			ולמלא את הפרטים -
          המערכת תזהה אתכם כהורים ותאפשר לכם גישה לתרגול אישי עבורכם.
        </Typography>
        <Typography marginTop={2}>
          <strong>ספיקינגפאל (SpeakingPal) </strong>
          היא חברת טכנולוגיית חינוך ישראלית בעלת פתרונות זוכי פרסים לתרגול
          הדיבור באנגלית. החברה פיתחה סימולטור שיחה בו המשתמש מנהל שיחת וידאו
          מול שחקנים שהוקלטו מראש. לצורך ניתוח השיחה משולבת טכנולוגיית זיהוי
          דיבור בעזרתה המשתמש מקבל משוב בזמן אמת. החוויה הווירטואלית דומה לניהול
          שיחה עם מתרגל אנושי, בדומה לשיחת זום.
        </Typography>
        <Typography marginTop={2}>
          <strong>לספיקינגפאל </strong>
			מיליוני משתמשים ברחבי העולם ובין לקוחות החברה נמנים משרדי חינוך, רשתות חינוך, חברות מסחריות ומשתמשים פרטיים. החברה נמצאת בחזית העולמית בפיתוח מערכות בינה מלאכותית לזיהוי דיבור לדוברי שפה זרה (AI), בפיתוח סימולטור לניהול שיחה ובשילוב מיומנויות רגשיות וחברתיות בסביבת לימוד מתוקשבת. ספיקינגפאל זכתה באתגר האנגלית הדבורה של משרד החינוך הישראלי בקיץ 2022 ונבחרה כפתרון הטוב ביותר ללימוד אנגלית דבורה בבתי הספר בישראל, ובפרס אתגר הSEL לשילוב מיומנויות רגשיות-חברתיות בשנת 2023 על ידי אגודת בוגרי 8200 ומשרד החינוך.
        </Typography>
        <Typography marginTop={2}>
          פרטים נוספים על סביבת הלימוד של SpeakingPal באתר החברה:
        </Typography>
        <a
          href="https://www.speakingpal.com/moe-program/moe.html"
          target="_blank"
        >
          <Typography marginTop={2}>
            https://www.speakingpal.com/moe-program/moe.html
          </Typography>
        </a>
      </Box>
      <Box
        sx={{
          textAlign: "center",
          display: {
            md: "flex",
            sm: "block",
          },
          width: {
            md: "80%",
            sm: "100%",
          },
          margin: "auto",
          justifyContent: "space-between",
          alignItems: "center",
          marginTop: 3
        }}
      >
        <img src={MOELogo} alt="MOELogo" height="100" />
        <img src={ClevelandJF} alt="ClevelandJF" height="100" />
        <img src={BSSTEM} alt="BSSTEM" height="100" />
        <img src={SellChallenge} alt="BSSTEM" height="100" />
      </Box>
    </Box>
  );
}
